class User {
  constructor (data) {
    this.id = data ? data.id : ''
    this.username = data ? data.username : ''
    this.role = data ? data.role : ''
    this.password = ''
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : false
    this.downloads = data ? data.downloads : -1
  }
}

export default User



// WEBPACK FOOTER //
// ./src/models/User.js